export enum FinanceStatuses {
    basket = 'basket',
    vehicleSummary = 'vehicle_summary',
    dealer = 'dealer',
}
